import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';

export const EventRsvpEditorAccessFragment = graphql(/* GraphQL */ `
  fragment EventRsvpEditorAccess on query_root {
    rsvpEditorPerson: person_by_pk(id: $subjectPersonId) {
      id
      rsvp_editor_access(
        limit: 1
        where: { event_id: { _eq: $eventId } }
        order_by: [{ priority: asc }, { team: { title: asc } }]
      ) {
        source
        team {
          id
          title
          home_primary_color
        }
      }
    }
  }
`);

type EventRsvpEditorAccess =
  | {
      canEdit: true;
      source: 'self' | 'person_manager' | 'event';
      team: null;
    }
  | {
      canEdit: true;
      source: 'team';
      team: {
        id: string;
        title: string;
        home_primary_color?: string | null;
      } | null;
    }
  | {
      canEdit: false;
      source: null;
      team: null;
    };

export function getEventRsvpEditorAccess({
  fragment,
  personId,
  subjectPersonId,
}: {
  fragment: FragmentOf<typeof EventRsvpEditorAccessFragment> | null | undefined;
  personId: string;
  subjectPersonId: string;
}): EventRsvpEditorAccess {
  const data = readFragment(EventRsvpEditorAccessFragment, fragment);
  const grant = data?.rsvpEditorPerson?.rsvp_editor_access[0];
  if (!grant) return { canEdit: false, source: null, team: null };
  if (personId === subjectPersonId) {
    return { canEdit: true, source: 'self', team: null };
  }
  if (grant.source === 'person_manager' || grant.source === 'event') {
    return { canEdit: true, source: grant.source, team: null };
  }
  if (grant.source === 'team') {
    return { canEdit: true, source: 'team', team: grant.team ?? null };
  }
  return { canEdit: false, source: null, team: null };
}
